import { Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import SEO, { LOCAL_BUSINESS_ID } from "../seo/SEO";
import "./Home.css";
import logo from "./logo.webp";
import slideshow1 from "./slideshow1.webp";
import slideshow2 from "./slideshow2.webp";
import slideshow3 from "./slideshow3.webp";
import slideshow4 from "./slideshow4.webp";
import slideshow5 from "./slideshow5.webp";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": LOCAL_BUSINESS_ID,
  name: "Pferdeosteopathie Laskowski",
  description:
    "Ganzheitliche Pferdeosteopathie und -physiotherapie in Hamburg und Umgebung. Osteopathie, Biotensegrales Training, Akupunktur, Dry Needling, Hofmag und Futterberatung.",
  url: "https://pferdeosteopathie-laskowski.de/",
  image: "https://pferdeosteopathie-laskowski.de/og-image.jpg",
  telephone: "+4915753382952",
  email: "info@pferdeosteopathie-laskowski.de",
  priceRange: "€€",
  address: {
    "@type": "PostalAddress",
    postalCode: "22147",
    addressLocality: "Hamburg",
    addressCountry: "DE",
  },
  areaServed: [
    { "@type": "City", name: "Hamburg" },
    { "@type": "AdministrativeArea", name: "Kreis Herzogtum Lauenburg" },
    { "@type": "AdministrativeArea", name: "Kreis Stormarn" },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "20:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Saturday", "Sunday"],
      opens: "00:00",
      closes: "00:00",
    },
  ],
  founder: { "@type": "Person", name: "Michelle Laskowski" },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Leistungen",
    itemListElement: [
      "Osteopathie und Physiotherapie",
      "Biotensegrales Training",
      "Akupunktur",
      "Dry Needling",
      "Hofmag Therapie",
      "Blutabnahme und Befundbesprechung",
      "Futterberatung und Rationsberechnung",
    ].map((s) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name: s },
    })),
  },
};

export default function Home() {
  return (
    <div id="home">
      <SEO
        title="Pferdeosteopathie Laskowski"
        description="Ganzheitliche Pferdeosteopathie und -physiotherapie in Hamburg und Umgebung. Termine für Osteopathie, Biotensegrales Training, Akupunktur, Dry Needling, Hofmag und Futterberatung."
        jsonLd={localBusinessSchema}
      />
      <Helmet>
        <link rel="preload" as="image" href={slideshow3} />
      </Helmet>
      <h1 className="visually-hidden">Pferdeosteopathie Laskowski - Pferdeosteopathie in Hamburg</h1>
      <Logo />
      <Spruch />
      <Slideshow />
    </div>
  );
}

function Slideshow() {
  return (
    <div className="slide-container-wrapper">
      <div className="slide-container">
        <Slide
          autoplay
          canSwipe
          infinite
          duration={3000}
          transitionDuration={800}
          easing="ease"
          indicators
        >
          <img src={slideshow3} alt="Eindruck aus der Pferdeosteopathie-Praxis" className="slideshow-picture" width={1280} height={853} loading="eager" fetchPriority="high" decoding="async" />
          <img src={slideshow4} alt="Pferd während einer ganzheitlichen Behandlung" className="slideshow-picture" width={1280} height={854} loading="lazy" decoding="async" />
          <img src={slideshow1} alt="Arbeit mit dem Pferd" className="slideshow-picture" width={1280} height={853} loading="lazy" decoding="async" />
          <img src={slideshow5} alt="Akupunktur-Behandlung" className="slideshow-picture" width={1280} height={853} loading="lazy" decoding="async" />
          <img src={slideshow2} alt="Pferd und Therapeutin in vertrauensvoller Zusammenarbeit" className="slideshow-picture" width={1280} height={853} loading="lazy" decoding="async" />
        </Slide>
      </div>
    </div>
  );
}

function Logo() {
  return (
    <div className="logo">
      <img src={logo} alt="Logo Pferdeosteopathie Laskowski" width={1280} height={1031} decoding="async" />
    </div>
  );
}

function Spruch() {
  return (
    <div className="spruch">
      <HR />
      <Typography variant="h5" component="p" textAlign="center">
        Dein Pferd im Mittelpunkt -
      </Typography>
      <Typography variant="h5" component="p" textAlign="center">
        ganzheitlich, tragfähig, individuell
      </Typography>
      <HR />
    </div>
  );
}

function HR() {
  return <div className="hr" />;
}
